<script setup lang="ts">
import { ExclamationTriangleIcon, CheckIcon } from '@heroicons/vue/24/outline'
import Modal from '../modal/Modal.vue'

interface Props {
    isOpen: boolean
    confirm?: boolean
    warning?: boolean
    sm?: boolean
    closable?: boolean
    blur?: boolean
    teleport?: string
}

withDefaults(defineProps<Props>(), {
    confirm: false,
    warning: false,
    sm: true,
    closable: false,
    blur: false,
    teleport: undefined,
})
</script>

<template>
    <Modal class="dialog" :sm="sm" :is-open="isOpen" :closable="closable" :blur="blur" :teleport="teleport">
        <template #header>
            <slot name="icon">
                <div class="dialog__icon">
                    <CheckIcon v-if="confirm" />
                    <ExclamationTriangleIcon v-if="warning" />
                </div>
            </slot>
        </template>
        <slot />

        <template #footer>
            <slot name="footer" />
        </template>
    </Modal>
</template>
